import React, { useRef } from 'react';
import { ModalWraper } from '../UI/styledConstants';
import IconClose from '../../assets/images/IconClose';
import logoBlack from '../../assets/images/logoBlack.svg';
import backgroundImg from '../../assets/images/bg-img.png';
import { clickOutside, downloadDivAsImage, isEmpty, numberToWords, overLayers } from '../../utils/common';
import bbpsLogo from '../../assets/images/bbpsLogo2.png';
import { useNavigate } from 'react-router-dom';
import successImg from '../../assets/images/successimg.png';
import { useEffect } from 'react';
import PremiumReceipt from '../PremiumReceipt/PremiumReceipt';
const BBPSReceipt = ({ payDaital, onCloseModal, billDetails = {}, label = '', amount, dynamicFieldValues, isLic=false }) => {
	const receiptRef = useRef(null);
	const handleDownloadClick = () => {
		if(isLic && payDaital?.status?.toLowerCase() === 'success'){
			receiptRef.current.downloadPDF()
			return
		}
		const divElement = document?.getElementById('model-BBPS-1');
	
		downloadDivAsImage(divElement, label);
	};
const boxRef  =  useRef(null)
	const navigate = useNavigate();

	
	const result = [];
	if(!isEmpty(dynamicFieldValues)){
		for (const key in dynamicFieldValues) {
			result.push({
				label: key,
				value: dynamicFieldValues[key],
			});
		}
	}
	


	useEffect(() =>{
		overLayers(true);
		clickOutside(true,boxRef,onCloseModal);
	
		return(() =>{
			overLayers(false)
			clickOutside(false,boxRef,onCloseModal);
		})
	
	},[]);


	return (
		<>
	
		<ModalWraper url={backgroundImg}>
			<div className="modal modal-success" id="model-BBPS-1" ref={boxRef}>
				<div className="flex modal-header justify-between">
					<div className="logo self-center">
						<img src={logoBlack} alt={'logo'} />
						<div>
							<p>Invoicing and payments</p>
							<p>powered by Pay2Mobile</p>
						</div>
					</div>

					<div className="buttons">
						<img src={bbpsLogo} alt="bbps logo" style={{ width: '115px' }} />
					</div>
				</div>
				<div className="modal-close" onClick={() => onCloseModal()}>
					<IconClose />
				</div>
				<div className="text-center modal-title">
					<p className="amount-text" style={{ fontSize: '20px' }}>{`${label} Bill Payment`}</p>
				</div>
				<div className="text-center modal-title">
					<h3 className="amount">₹ {amount}</h3>
					<p className="amount-text">{numberToWords(amount)}</p>
				</div>

				<div className="modal-body ">
					<div className="txn-daital">
						<div className="flex justify-between txn-daital-h">
							<div></div>
							<div></div>
						</div>
						{!isEmpty(payDaital?.status) && (
							<div className="flex justify-between txn-desc">
								<div className="txn-desc-right fs-sm-12">
									<div>
										<span className="fs-sm-12">Status</span>
									</div>
								</div>
								<div className="txn-desc-left fs-sm-12">
									<div>
										<span>
											<div className="detail-desc success fs-sm-12">
												{payDaital?.status?.toLowerCase() === 'success' ? (
													<>
														<img src={successImg} alt={'success'} />
														{payDaital?.status}
													</>
												) : (
													<span style={{ color: 'red' }}> {payDaital?.status}</span>
												)}
											</div>
										</span>
									</div>
								</div>
							</div>
						)}
						{!isEmpty(billDetails?.billerResponse?.customerName) && (
							<div className="flex justify-between txn-desc">
								<div className="txn-desc-right fs-sm-12">
									<div>
										<span>Customer Name</span>
									</div>
								</div>
								<div className="txn-desc-left fs-sm-12">
									<div>
										<span>{billDetails?.billerResponse?.customerName}</span>
									</div>
								</div>
							</div>
						)}
						{!isEmpty(billDetails?.billerResponse?.billPeriod) && (
							<div className="flex justify-between txn-desc">
								<div className="txn-desc-right fs-sm-12">
									<div>
										<span>Bill Period.</span>
									</div>
								</div>
								<div className="txn-desc-left fs-sm-12">
									<div>
										<span>{billDetails?.billerResponse?.billPeriod}</span>
									</div>
								</div>
							</div>
						)}

						{!isEmpty(result) &&
							result.map((val, index) => {
							
								if(val?.label.toLowerCase() == "amount"){
									return "";
								}
								return (
									<div className="flex justify-between txn-desc" key={index}>
										<div className="txn-desc-right fs-sm-12">
											<div>
												<span>{val?.label}</span>
											</div>
										</div>
										<div className="txn-desc-left fs-sm-12">
											<div>
												<span>{val?.value}</span>
											</div>
										</div>
									</div>
								);
							})}

						{
							<div className="flex justify-between txn-desc">
								<div className="txn-desc-right fs-sm-12">
									<div>
										<span>CCF</span>
									</div>
								</div>
								<div className="txn-desc-left fs-sm-12">
									<div>
										<span>₹ {billDetails?.billerResponse?.custConvFee || '0'}</span>
									</div>
								</div>
							</div>
						}

						{
							<div className="flex justify-between txn-desc">
								<div className="txn-desc-right fs-sm-12">
									<div>
										<span>Bill Amount</span>
									</div>
								</div>
								<div className="txn-desc-left fs-sm-12">
									<div>
										<span>₹ {amount}</span>
									</div>
								</div>
							</div>
						}

						{!isEmpty(payDaital?.response?.txnDateTime) && (
							<div className="flex justify-between txn-desc">
								<div className="txn-desc-right fs-sm-12">
									<div>
										<span>Date</span>
									</div>
								</div>
								<div className="txn-desc-left fs-sm-12">
									<div>
										<span>{payDaital?.response?.txnDateTime}</span>
									</div>
								</div>
							</div>
						)}
						{!isEmpty(billDetails?.billerResponse?.billNumber) && (
							<div className="flex justify-between txn-desc">
								<div className="txn-desc-right fs-sm-12">
									<div>
										<span>Bill Number</span>
									</div>
								</div>
								<div className="txn-desc-left fs-sm-12">
									<div>
										<span>{billDetails?.billerResponse?.billNumber}</span>
									</div>
								</div>
							</div>
						)}
						{!isEmpty(payDaital?.response?.txnReferenceId) && (
							<div className="flex justify-between txn-desc">
								<div className="txn-desc-right fs-sm-12">
									<div>
										<span>B-Connect Txn ID</span>
									</div>
								</div>
								<div className="txn-desc-left fs-sm-12">
									<div>
										<span>{payDaital?.response?.txnReferenceId}</span>
									</div>
								</div>
							</div>
						)}
						{!isEmpty(payDaital?.response?.refId) && (
							<div className="flex justify-between txn-desc">
								<div className="txn-desc-right fs-sm-12">
									<div>
										<span>Reference Id</span>
									</div>
								</div>
								<div className="txn-desc-left fs-sm-12">
									<div>
										<span>{payDaital?.response?.refId}</span>
									</div>
								</div>
							</div>
						)}
					</div>
				</div>

				<div className="buttons center gap-10" style={{ marginTop: '40px' }}>
					<button className="button-solid center gap-6" onClick={() => handleDownloadClick()}>
						<i className="fa-solid fa-download"></i> {!isLic?"Download":"Download LIC  Receipt"} 
					</button>
					{ !isLic && <button className="button-solid center gap-6" onClick={() => window.print()}>
						<i className="fa-solid fa-print"></i> Print
					</button>}
					{payDaital?.status?.toUpperCase() !== 'FAILURE' && (
						<button class="button-solid center gap-6" onClick={() => navigate('/bbpscomplaint', { state: payDaital?.response })}>
							<i class="fa-solid fa-file-circle-exclamation"></i> Complaint
						</button>
					)}
				</div>
			</div>
			
		</ModalWraper>
		{isLic &&<div style={{opacity:"0",position:"fixed",zIndex:"-1"}}>
			<PremiumReceipt ref={receiptRef} payDaital={payDaital} billDetails={billDetails} policyNo={dynamicFieldValues?.['Policy Number']}  />
		</div>}
		</>
	);
};

export default BBPSReceipt;
